export const CouponLogType = {
    AUTO_ISSUED: "자동발행쿠폰",
    GENERIC: "미지정쿠폰",
    ITEM_SPECIFIC: "지정쿠폰",
    NON_MEMBER: "비회원쿠폰",
} as const;
